var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from 'react';
import { errorManager } from '../utils';
import { injectIntl } from 'react-intl';
var defaultMessage = "Leider k\u00F6nnen wir im Moment nicht alle Informationen abrufen.\n                        Bitte probieren Sie es sp\u00E4ter noch einmal.";
var ErrorBoundary = (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.errorInterceptor = function (error) {
            if (!_this.props.silent) {
                console.error('error occurred:', error);
            }
            _this.setState({
                error: error || true,
            });
        };
        _this.state = {
            error: null,
        };
        return _this;
    }
    ErrorBoundary.prototype.componentDidMount = function () {
        errorManager.use(this.errorInterceptor);
    };
    ErrorBoundary.prototype.componentWillUnmount = function () {
        errorManager.eject(this.errorInterceptor);
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        if (!this.state.error) {
            this.setState({
                error: error || true,
            });
        }
        if (!this.props.silent) {
            console.error('component error caught', error, info);
        }
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.error) {
            return (React.createElement("div", { className: "error-container" },
                React.createElement("div", { className: "alert alert-danger" }, this.props.errorMessage)));
        }
        return React.createElement(React.Fragment, null, this.props.children || null);
    };
    ErrorBoundary.defaultProps = {
        errorMessage: defaultMessage,
        silent: false,
    };
    return ErrorBoundary;
}(PureComponent));
export { ErrorBoundary };
export var IntlErrorBoundary = function (_a) {
    var children = _a.children, _b = _a.messageKey, messageKey = _b === void 0 ? 'msg.appError' : _b, intl = _a.intl, silent = _a.silent;
    var errorMessage = intl.formatMessage({ id: messageKey });
    return (React.createElement(ErrorBoundary, { errorMessage: errorMessage, silent: silent }, children));
};
export function withIntlErrorBoundary() {
    return function withIntlErrorBoundaryHoc(Component) {
        function Wrapper(props) {
            var ErrorBoundary = injectIntl(IntlErrorBoundary);
            return (React.createElement(ErrorBoundary, null,
                React.createElement(Component, __assign({}, props))));
        }
        return Wrapper;
    };
}
//# sourceMappingURL=ErrorBoundary.js.map